import { render, staticRenderFns } from "./LastMinutes.vue?vue&type=template&id=4a6b22cd&scoped=true&"
import script from "./LastMinutes.vue?vue&type=script&lang=js&"
export * from "./LastMinutes.vue?vue&type=script&lang=js&"
import style0 from "./LastMinutes.vue?vue&type=style&index=0&id=4a6b22cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b22cd",
  null
  
)

export default component.exports